// ▶ Pedido dela 14/10: o cartao do pedido mostra a data da ULTIMA ALTERACAO, e
// nao a de criacao -- um pedido feito em 25/09 e mexido hoje tem de mostrar hoje.
// Alterar um pedido quase nunca toca a linha do `pedidos`: o que muda e o
// sub-pedido (total, status) e os itens. Por isso a data e a maior entre os tres.
//
// `atualizado_em` e do servidor (trigger): sem rede a data so anda quando o app
// sincroniza. As datas sao ISO, entao comparar texto basta.
export function ultimaAlteracaoDoPedido(
  pedido: { id: string; atualizado_em: string },
  subPedidos: { id: string; pedido_id: string; atualizado_em: string }[],
  // Maior `atualizado_em` dos itens de cada sub-pedido (chave: id do sub-pedido).
  itensPorSubPedido: Map<string, string>,
): string {
  let maior = pedido.atualizado_em
  for (const sub of subPedidos) {
    if (sub.pedido_id !== pedido.id) continue
    if (sub.atualizado_em > maior) maior = sub.atualizado_em
    const doItem = itensPorSubPedido.get(sub.id)
    if (doItem && doItem > maior) maior = doItem
  }
  return maior
}
